import styled from "@emotion/styled";
export const StyledCompetitorSignupForm = styled.div`
    margin: 32px 20px 100px 20px;
    display: flex;
    justify-content: center;
`;
export const StyledFooterDisclaimer = styled.div`
  font-size: 0.8125rem;
  width: 100%;
  padding: 16px 50px;
`;
